import dayjs from "dayjs"

/**
 * When display dates tie, prefer higher-value editorial content over
 * downloadable assets. Matches the merge order in `cardQueries.ts`.
 */
export const RESOURCE_TYPE_SORT_PRIORITY: Record<string, number> = {
  Article: 0,
  CustomerStory: 1,
  CaseStudy: 2,
  Video: 3,
  ExternalResource: 4,
  Document: 5,
}

type SortableResourceCard = {
  displayDate?: unknown
  date?: unknown
  __typename?: string
  typeName?: string
}

function getDateValue(date: unknown): number {
  if (date === null || date === undefined || date === "") return 0
  const value = dayjs(date as string | number | Date).valueOf()
  return Number.isFinite(value) ? value : 0
}

function getTypePriority(typeName: string | undefined): number {
  if (!typeName) return 99
  return RESOURCE_TYPE_SORT_PRIORITY[typeName] ?? 99
}

export function compareResourceGridByDate(
  a: SortableResourceCard,
  b: SortableResourceCard,
  direction: "newest" | "oldest" = "newest",
): number {
  const dateA = getDateValue(a.displayDate ?? a.date)
  const dateB = getDateValue(b.displayDate ?? b.date)

  if (dateA !== dateB) {
    return direction === "oldest" ? dateA - dateB : dateB - dateA
  }

  return (
    getTypePriority(a.__typename ?? a.typeName) -
    getTypePriority(b.__typename ?? b.typeName)
  )
}
